export enum ListFilterOwnership {
  General = 'general',
  Joined = 'joined',
}
